import { DEFAULT_SUPPORT_CONTACT } from '@/providers/support-contact';
import type { SupportContact } from '@/providers/support-contact/types';

interface SupportContactFields {
  supportPhoneDisplay?: string;
  supportPhoneTel?: string;
  supportEmail?: string;
}

// Resolve the Studio support fields into a SupportContact, falling back to the
// shared constant defaults for any empty/blank field. Locale resolution is
// handled upstream by Studio (translatable fields arrive already localized).
const resolveSupportContact = (data: SupportContactFields): SupportContact => ({
  phone: {
    display: data.supportPhoneDisplay?.trim() || DEFAULT_SUPPORT_CONTACT.phone.display,
    tel: data.supportPhoneTel?.trim() || DEFAULT_SUPPORT_CONTACT.phone.tel,
  },
  email: data.supportEmail?.trim() || DEFAULT_SUPPORT_CONTACT.email,
});

export default resolveSupportContact;
